import { Platform } from 'react-native';
import * as Haptics from 'expo-haptics';

const isNative = Platform.OS === 'ios' || Platform.OS === 'android';

/**
 * Haptic feedback utilities for iOS/Android.
 * All functions are safe to call on web (no-ops).
 */

/** Light tap — for UI selections, toggles, button presses */
export function lightTap() {
  if (!isNative) return;
  Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light).catch(() => {});
}

/** Medium tap — for confirmations, navigation actions */
export function mediumTap() {
  if (!isNative) return;
  Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium).catch(() => {});
}

/** Heavy tap — for destructive actions, important confirmations */
export function heavyTap() {
  if (!isNative) return;
  Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy).catch(() => {});
}

/** Selection changed — for pickers, sliders */
export function selectionChanged() {
  if (!isNative) return;
  Haptics.selectionAsync().catch(() => {});
}

/** Success notification — for completed actions */
export function notifySuccess() {
  if (!isNative) return;
  Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success).catch(() => {});
}

/** Warning notification */
export function notifyWarning() {
  if (!isNative) return;
  Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning).catch(() => {});
}

/** Error notification */
export function notifyError() {
  if (!isNative) return;
  Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error).catch(() => {});
}
